import { studentDay } from './studentDates';
function kolkataDay(value) { return studentDay(value); }
function feeCycle(student) {
  const join = kolkataDay(student.joinDate);
  if (!join) return '';
  const history = student.readmissionHistory || [];
  const latest = history[history.length - 1];
  return `${join}:${latest?.changedAt ? new Date(latest.changedAt).toISOString() : 'recorded-cycle'}`;
}
function nonChargeable(student, month) {
  const cycle = feeCycle(student);
  return Boolean(cycle && (student.nonChargeablePeriods || []).some(period => period.cycle === cycle && period.approvedAt && period.fromMonth <= month && month <= period.toMonth));
}
function studentTenure(student, asOf) {
  const start = kolkataDay(student.joinDate), today = kolkataDay(asOf);
  const inactive = student.status !== 'active';
  const leaving = kolkataDay(student.leavingDate);
  if (!start || !today || (inactive && !leaving)) return { months: null, label: 'Unknown', start, end: '' };
  const end = inactive && leaving < today ? leaving : today;
  if (end < start) return start > today ? { months: 0, label: 'Not started', start, end, future: true } : { months: null, label: 'Unknown', start, end };
  const [sy, sm, sd] = start.split('-').map(Number), [ey, em, ed] = end.split('-').map(Number);
  let months = (ey - sy) * 12 + em - sm;
  const last = new Date(Date.UTC(ey, em, 0)).getUTCDate();
  if (ed < Math.min(sd, last)) months--;
  months = Math.max(0, months);
  return { months, label: `${String(Math.floor(months / 12)).padStart(2,'0')}y ${String(months % 12).padStart(2,'0')}m`, start, end };
}
export { kolkataDay, feeCycle, nonChargeable, studentTenure };
